<template>
  <a-table :columns="columns" :data-source="themeRamItems" :pagination="false">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'themeId'">
        {{ getThemeName(record.themeId) }}
      </template>
      <template v-else-if="column.key === 'ram'">
        {{ record['ram'] }}kb
      </template>
      <template v-else-if="column.key === 'limit'">
        {{ maxRamLimit }}kb
      </template>
      <template v-else-if="column.key === 'isOverLimit'">
        <span v-if="record['ram'] > maxRamLimit" class="text-red-500">
          超标</span
        >
        <span v-else>否</span>
      </template>
      <template v-else-if="column.key === 'action'">
        <a-button size="small" @click="() => handleLayerClick(record)"
          >查看</a-button
        >
      </template>
    </template>
  </a-table>
</template>

<script setup lang="ts">
import { ThemeRamItem, useWatchfaceRam } from '@/hooks';
import { useEditorStore } from '@/store/use-editor-store';
import { useLayerStore } from '@/store/use-layer-store';
import { ref } from 'vue';

const { maxRamLimit, themeRamItems } = useWatchfaceRam();

const layerStore = useLayerStore();
const editorStore = useEditorStore();

const columns = [
  {
    title: '所属样式',
    key: 'themeId'
  },
  {
    title: '图片占用内存',
    key: 'ram'
  },
  {
    title: '允许内存上限',
    key: 'limit'
  },
  {
    title: '是否超标',
    key: 'isOverLimit'
  },
  { title: '操作', key: 'action' }
];

const visible = ref(false);

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const handleLayerClick = (i: ThemeRamItem) => {
  visible.value = false;
  editorStore.selectTheme(i.themeId);
  emit('close');
};

const getThemeName = (themeId: string) => {
  const theme = layerStore.findTheme(themeId);
  if (!theme) return '-';
  if (theme.type == 'normal') return theme.name;

  // 查找对应的亮屏
  const normalTheme = layerStore.themes.find(
    (item) => item.name == theme.name && item.type == 'normal'
  );
  if (!normalTheme) return '-';
  if (layerStore.themes.filter((item) => item.type == 'AOD').length < 2)
    return '息屏';
  return normalTheme.name + '的息屏';
};
</script>
<style lang="less"></style>
